import { render, staticRenderFns } from "./PublishPostCard.vue?vue&type=template&id=0a60057d"
import script from "./PublishPostCard.vue?vue&type=script&lang=ts"
export * from "./PublishPostCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports